import React, { useState } from 'react';
import { Search, Plus, Edit2, Trash2, MoreVertical, Filter, Download } from 'lucide-react';
export function VendorView() {
  const [vendors, setVendors] = useState([{
    id: 1,
    name: 'Sysco Foods',
    category: 'Food',
    subCategory: 'Dairy, Dry Goods',
    status: 'Active'
  }, {
    id: 2,
    name: 'Restaurant Depot',
    category: 'Food',
    subCategory: 'Meat, Produce',
    status: 'Active'
  }, {
    id: 3,
    name: 'Profish',
    category: 'Food',
    subCategory: 'Seafood',
    status: 'Active'
  }, {
    id: 4,
    name: 'Coastal Sunbelt',
    category: 'Food',
    subCategory: 'Produce',
    status: 'Active'
  }, {
    id: 5,
    name: 'PepsiCo',
    category: 'Beverages',
    subCategory: 'Soda',
    status: 'Active'
  }, {
    id: 6,
    name: 'Wash Gas',
    category: 'Utilities',
    subCategory: 'Gas',
    status: 'Active'
  }]);
  return <div className="space-y-6" data-id="element-522">
      <div className="flex items-center justify-between" data-id="element-523">
        <div data-id="element-524">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-525">
            Vendor Management
          </h2>
          <p className="text-sm text-slate-500" data-id="element-526">
            Master data for purchasing and COGS tracking
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-527">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-528">
            <Download size={14} data-id="element-529" />
            Export List
          </button>
          <button className="flex items-center gap-2 px-6 py-2 bg-slate-900 text-white rounded-xl text-sm font-bold shadow-lg shadow-slate-900/20 hover:bg-slate-800 transition-all" data-id="element-530">
            <Plus size={16} data-id="element-531" />
            Add New Vendor
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-532">
        <div className="p-4 border-b border-slate-50 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-533">
          <div className="relative flex-1 max-w-md" data-id="element-534">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-535" />
            <input type="text" placeholder="Search vendors by name or category..." className="w-full pl-10 pr-4 py-2 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-slate-900/5 focus:border-slate-900 outline-none transition-all" data-id="element-536" />
          </div>
          <div className="flex items-center gap-2" data-id="element-537">
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-all" data-id="element-538">
              <Filter size={18} data-id="element-539" />
            </button>
            <div className="h-4 w-[1px] bg-slate-200 mx-1" data-id="element-540" />
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-541">
              Showing {vendors.length} Vendors
            </p>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-542">
          <table className="w-full text-left" data-id="element-543">
            <thead data-id="element-544">
              <tr className="bg-slate-50/50" data-id="element-545">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-546">
                  Vendor Name
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-547">
                  Category
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-548">
                  Sub-Category
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-549">
                  Status
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-550">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-551">
              {vendors.map(vendor => <tr key={vendor.id} className="hover:bg-slate-50 transition-colors group" data-id="element-552">
                  <td className="px-6 py-4" data-id="element-553">
                    <div className="flex items-center gap-3" data-id="element-554">
                      <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center text-xs font-bold text-slate-600" data-id="element-555">
                        {vendor.name.charAt(0)}
                      </div>
                      <span className="text-sm font-bold text-slate-900" data-id="element-556">
                        {vendor.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-557">
                    <span className="px-2 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold rounded-md uppercase" data-id="element-558">
                      {vendor.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-xs font-medium text-slate-500" data-id="element-559">
                    {vendor.subCategory}
                  </td>
                  <td className="px-6 py-4" data-id="element-560">
                    <span className="flex items-center gap-1.5 text-[10px] font-bold text-emerald-600" data-id="element-561">
                      <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full" data-id="element-562" />
                      {vendor.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-563">
                    <div className="flex items-center justify-end gap-1" data-id="element-564">
                      <button className="p-2 text-slate-300 hover:text-slate-600 transition-colors" data-id="element-565">
                        <Edit2 size={14} data-id="element-566" />
                      </button>
                      <button className="p-2 text-slate-300 hover:text-rose-500 transition-colors" data-id="element-567">
                        <Trash2 size={14} data-id="element-568" />
                      </button>
                      <button className="p-2 text-slate-300 hover:text-slate-600 transition-colors" data-id="element-569">
                        <MoreVertical size={14} data-id="element-570" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}